import { render, staticRenderFns } from "./CarouselInterval.vue?vue&type=template&id=09bd6b28&"
import script from "./CarouselInterval.vue?vue&type=script&lang=js&"
export * from "./CarouselInterval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports